import { createContext, useContext, useMemo } from 'react';
import { useNavigationType } from 'react-router-dom';

/* ─── NavigationContext ───
   1. isBack — 同步检测 POP 导航，用于跳过入场动画
   滚动位置由 useScrollRestore hook 统一管理
   ─────────────────────── */

interface NavigationContextValue {
  /** 当前导航是否为后退 (POP) — 同步可用，不经过 useEffect */
  isBack: boolean;
}

const NavigationContext = createContext<NavigationContextValue>({ isBack: false });

export function useNavigation() {
  return useContext(NavigationContext);
}

export function NavigationProvider({ children }: { children: React.ReactNode }) {
  const navType = useNavigationType();
  const isBack = navType === 'POP';

  const value = useMemo(() => ({ isBack }), [isBack]);

  return (
    <NavigationContext.Provider value={value}>
      {children}
    </NavigationContext.Provider>
  );
}
